import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import '@fortawesome/fontawesome-free/css/all.css'
import VueLazyLoad from 'vue3-lazy'

const app = createApp(App)

app.use(router)

app.use(VueLazyLoad, {
  loading: '/spinner.gif',
})

app.directive('reveal', {
  mounted(el, binding) {
    const delay = binding.value?.delay || 0
    const y = binding.value?.y || 28
    const duration = binding.value?.duration || 700

    el.style.opacity = '0'
    el.style.transform = `translateY(${y}px)`
    el.style.transition = `
      opacity ${duration}ms ease,
      transform ${duration}ms ease
    `
    el.style.transitionDelay = `${delay}ms`
    el.style.willChange = 'opacity, transform'

    const reveal = () => {
      el.style.opacity = '1'
      el.style.transform = 'translateY(0)'
    }

    // Wichtig: Falls IntersectionObserver nicht sofort triggert,
    // wird trotzdem sichtbar gemacht.
    const fallbackTimer = window.setTimeout(reveal, delay + 1200)

    if (!('IntersectionObserver' in window)) {
      window.setTimeout(reveal, delay)
      return
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          window.clearTimeout(fallbackTimer)
          reveal()
          observer.unobserve(el)
        }
      },
      {
        threshold: 0.01,
        rootMargin: '0px 0px -5% 0px',
      }
    )

    observer.observe(el)

    // Für Elemente, die beim Laden schon sichtbar sind.
    window.requestAnimationFrame(() => {
      const rect = el.getBoundingClientRect()
      const isAlreadyVisible =
        rect.top < window.innerHeight &&
        rect.bottom > 0

      if (isAlreadyVisible) {
        window.clearTimeout(fallbackTimer)
        reveal()
        observer.unobserve(el)
      }
    })
  },
})

app.mount('#app')